import React from "react";
import s from './Home.module.scss'
import {ThisDay} from "./ThisDay/ThisDay";
import {ThisDayInfo} from "./ThisDayInfo/ThisDayInfo";
import {Days} from "../Days/Days";

export const Home = ({data, forecast}: any) => {


    return (
        <div className={s.home}>
            <div className={s.wrapper}>
                <ThisDay data={data}/>
                <ThisDayInfo data={data}/>
            </div>
            <Days forecast={forecast}/>
        </div>
    )
}